export default "__VITE_ASSET__BQc$m6F6__"